import { setAsyncGlobalDependencies } from 'modules/editCreate/actions';

export const editDependencies = ({ dispatch, field, value }) => {
	dispatch(setAsyncGlobalDependencies({ [field]: value }));
};
